import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PageTitle from "../../../components/layout/PageTitle";
import Wrapper from "../../../components/layout/Wrapper";
import SectionBar from "../../../components/cards/SectionBar";
import SectionItemBar from "../../../components/cards/SectionItemBar";
import HeaderStructure from "./HeaderStructure";
import {ADMIN_API_BASE, COURSE_API_BASE} from "../../../utils/apiConfig";
import {useAuth} from "../../../context/AuthProvider";
import {useParams} from "react-router-dom";

const MyCourseStructure = () => {
    const {user} = useAuth();

    const [course, setCourse] = useState(null);
    const [paid_levels, setPaidLevels] = useState(0);
    const [has_bought, setHasBought] = useState(false);
    const [course_level, setCourseLevel] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { course_id: courseId } = useParams();
    useEffect(() => {
        if (!user?.id || !courseId) {
            return;
        }

        const getCourseStructure = async () => {
            try {
                setLoading(true);
                setError(null);

                const response = await axios.get(
                    `${COURSE_API_BASE}/${courseId}/structure`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.data?.success) {
                    setCourse(response.data.course.course);
                    setPaidLevels(response.data.course.course.paid_levels);
                    setHasBought(response.data.course.course.has_bought);
                    setCourseLevel(response.data.course.course.course_level);
                } else {
                    setError(
                        response.data?.message ||
                        "خطا در دریافت ساختار دوره"
                    );
                }
            } catch (err) {
                console.error("GET COURSE STRUCTURE ERROR:", err);

                setError(
                    err.response?.data?.message ||
                    "خطا در دریافت ساختار دوره"
                );
            } finally {
                setLoading(false);
            }
        };

        getCourseStructure();
    }, [user?.id, courseId]);

    if (loading) {
        return (
            <div className='min-h-screen flex flex-col'>
                <HeaderStructure
                    xp={user?.xp}
                    credit={user?.credit}
                    streak={user?.streak}
                    courseId={courseId}
                />

                <main className='flex-1'>
                    <Wrapper>
                        <div className='py-8'>
                            در حال دریافت محتوای دوره...
                        </div>
                    </Wrapper>
                </main>
            </div>
        );
    }

    if (error) {
        return (
            <div className='min-h-screen flex flex-col'>
                <HeaderStructure
                    xp={user?.xp}
                    credit={user?.credit}
                    streak={user?.streak}
                    courseId={courseId}
                />

                <main className='flex-1 mb-10'>
                    <Wrapper>
                        <div className='py-8 text-red-500'>
                            {error}
                        </div>
                    </Wrapper>
                </main>
            </div>
        );
    }

    if (!course) {
        return null;
    }

    return (
        <div className='min-h-screen flex flex-col'>
            <HeaderStructure
                xp={user?.xp}
                credit={user?.credit}
                streak={user?.streak}
                courseId={courseId}
            />

            <main className='flex-1 mb-20'>
                <Wrapper>
                    <div>
                        {course.sections?.map((section, sectionIndex) => {
                            const contents = section.contents || [];

                            /*
                             * course_level represents the user's current progress.
                             * The next level is therefore also accessible.
                             */
                            const nextLevel = course_level + 1;

                            const isContentAccessible = (content) => {
                                const lockedByPayment =
                                    !has_bought &&
                                    content.level > paid_levels;

                                const lockedByProgress =
                                    content.level > nextLevel;

                                return !lockedByPayment && !lockedByProgress;
                            };

                            /*
                             * A section is enabled if it contains at least one
                             * lesson the user can currently access.
                             */
                            const sectionEnabled = contents.some(isContentAccessible);

                            return (
                                <SectionBar
                                    key={section.id}
                                    title={section.title}
                                    rank={sectionIndex + 1}
                                    enabled={sectionEnabled}
                                >
                                    {contents.map((content, contentIndex) => {
                                        const lockedByPayment =
                                            !has_bought &&
                                            content.level > paid_levels;

                                        const lockedByProgress =
                                            content.level > nextLevel;

                                        const itemEnabled =
                                            !lockedByPayment &&
                                            !lockedByProgress;

                                        return (
                                            <SectionItemBar
                                                key={content.id}
                                                title={content.title}
                                                rank={contentIndex + 1}
                                                hasBBorder={
                                                    contentIndex !== contents.length - 1
                                                }
                                                to={`/fa/account/course/${courseId}/content/${content.id}`}
                                                typ={content.type}
                                                enabled={itemEnabled}
                                                xp={content.xp}
                                                credit={content.credit}
                                            />
                                        );
                                    })}
                                </SectionBar>
                            );
                        })}
                    </div>
                </Wrapper>
            </main>
        </div>
    );
};

export default MyCourseStructure;